import { render } from "./DefaultModal.vue?vue&type=template&id=267a7ec4"
import script from "./DefaultModal.vue?vue&type=script&lang=js"
export * from "./DefaultModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macmini/Sites/self-ship/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__